import React, { FC } from 'react';
import { AuthenticationContainer } from '@components/organisms/AuthenticationContainer';
import { PasswordRecoveryCard } from '@components/molecules/authentication/PasswordRecoveryCard';

export const PasswordRecovery: FC = () => {
    return (
        <AuthenticationContainer>
            <PasswordRecoveryCard />
        </AuthenticationContainer>
    );
};
